// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21Sxs","name":"Header_name__ApdVx","birthday":"Header_birthday__1JUJ_","skeleton":"Header_skeleton__2o63f"};